export const API_PROJECTS_TRANSLATIONS_FIELDS = [
    'translations.id',
    'translations.languages_code',
    'translations.name',
    'translations.header_image_data_text',
    'translations.description',
    'translations.circle_image.id'
];
